import React from 'react';
import { useSelector } from 'react-redux';

import Alert from '@fmbt/ui/Alert';
import LoadingSpinner from 'components/composites/LoadingSpinner';
import { useBackOfficeEnterprise } from 'store/modules/backOfficeEnterprise/hooks';
import { makeSelectFirstErrorMessage } from 'store/modules/error/selectors';
import { EnterpriseId } from 'types/models/enterprise';

const actions = ['LOAD_BACK_OFFICE_ENTERPRISE'];

export const selectErrorMessage = makeSelectFirstErrorMessage(actions);

interface Props {
  children: JSX.Element;
  enterpriseId: EnterpriseId | undefined;
}

function BackOfficeEnterpriseLoadingGate({
  children,
  enterpriseId
}: Props): JSX.Element {
  const backOfficeEnterprise = useBackOfficeEnterprise();
  const errorMessage = useSelector(selectErrorMessage);

  if (backOfficeEnterprise && backOfficeEnterprise.id === enterpriseId) {
    return children;
  }

  if (errorMessage) {
    return <Alert message={errorMessage} />;
  }

  return <LoadingSpinner />;
}

export default BackOfficeEnterpriseLoadingGate;
